import { CONTENT_TYPE } from '../../constants';
import { DEFAULT_ALPHA_BLEND_MODE } from '../../constants/AlphaBlendModes';
import {
  DEFAULT_KEYFRAME_NUMBER,
  DEFAULT_KEYFRAME_TRANSFORM,
} from '../../features/creative/constants';

import { deepCopy } from '../../util/object';
import {
  TIME_RANGE_ABSOLUTE_MAX_FRAME,
  TIME_RANGE_MIN_FRAME,
} from '../shared/creative/state-management/constants';
import { GROUP_ROLES } from 'content-creation-common/constants/group';
export { GROUP_ROLES };

export const GROUP_CONTENT_TYPES = new Set([
  CONTENT_TYPE.ELEMENT_EFFECT_GROUP,
  CONTENT_TYPE.ELEMENT_GROUP,
]);

export const DEFAULT_GROUP_ELEMENT = {
  contentId: undefined,
  alphaCompositeRule: DEFAULT_ALPHA_BLEND_MODE,
  editedTransform: null,
  elementId: undefined,
  frameEnd: TIME_RANGE_ABSOLUTE_MAX_FRAME, // TODO grab actual max frame.
  frameStart: TIME_RANGE_MIN_FRAME,
  isEditingTransform: false,
  isTransformedByUser: false,
  meta: {},
  name: null,
  transforms: {
    [DEFAULT_KEYFRAME_NUMBER]: deepCopy(DEFAULT_KEYFRAME_TRANSFORM),
  },
};

export const DEFAULT_GROUP_CONTENT = {
  contentId: undefined,
  contentElementIds: [],
  contentType: CONTENT_TYPE.ELEMENT_GROUP,
  isOpen: false,
};
